import type { RouteObject } from 'react-router-dom';

import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';

import { paths } from '@/routes/paths';

const SettingsPage = lazy(() =>
  import('./pages/settings-page').then((m) => ({ default: m.SettingsPage })),
);

const wrap = (
  <Suspense fallback={null}>
    <SettingsPage />
  </Suspense>
);

// Children of `<SettingsLayout>` (mounted at `/settings`). The same SettingsPage
// dispatches by route :section param; bare /settings redirects into Account.
export const settingsRoutes: RouteObject[] = [
  { index: true, element: <Navigate to={paths.settings.account} replace /> },
  { path: ':section', element: wrap },
];
